<template>
  <div>
    <div class="footer">
      <div class="w1300">
        <div class="box">
          <div class="le">
            <div class="logo">
              <router-link to="/">
                <el-image
                  :src="shu.synopsis.dibulogo"
                  fit="contain"
                  v-if="shu.synopsis.dibulogo"
                ></el-image>
              </router-link>
            </div>
            <dl>
              <dd>
                <div class="icBox">
                  <svg
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M153.236734 163.111422l714.763665 0c48.810633 0 88.718697 38.475467 89.332667 85.853503l-446.458679 242.518237L64.313381 249.169581C64.722694 201.689218 104.323773 163.111422 153.236734 163.111422L153.236734 163.111422zM64.313381 341.981413l-0.409313 429.062856c0 47.787349 40.215049 86.876786 89.332667 86.876786l714.763665 0c49.117618 0 89.332667-39.089437 89.332667-86.876786L957.333067 341.776756 521.311882 573.038873c-6.651344 3.581493-14.735285 3.581493-21.386629 0L64.313381 341.981413 64.313381 341.981413zM64.313381 341.981413"
                      p-id="2702"
                      fill="#868686"
                    ></path>
                  </svg>
                </div>
                <div>
                  <div class="p1">商业合作</div>
                  <div class="p2">
                    <a href="mailto:business@unix-group.ai">
                      {{ shu.synopsis.hezuopeizhi.hezuo }}
                    </a>
                  </div>
                </div>
              </dd>

              <dd>
                <div class="icBox">
                  <svg
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M153.236734 163.111422l714.763665 0c48.810633 0 88.718697 38.475467 89.332667 85.853503l-446.458679 242.518237L64.313381 249.169581C64.722694 201.689218 104.323773 163.111422 153.236734 163.111422L153.236734 163.111422zM64.313381 341.981413l-0.409313 429.062856c0 47.787349 40.215049 86.876786 89.332667 86.876786l714.763665 0c49.117618 0 89.332667-39.089437 89.332667-86.876786L957.333067 341.776756 521.311882 573.038873c-6.651344 3.581493-14.735285 3.581493-21.386629 0L64.313381 341.981413 64.313381 341.981413zM64.313381 341.981413"
                      p-id="2702"
                      fill="#868686"
                    ></path>
                  </svg>
                </div>
                <div>
                  <div class="p1">销售联系</div>
                  <div class="p2">
                    <a href="mailto:sales@unix-group.ai"
                      >{{ shu.synopsis.hezuopeizhi.xiaoshoulianxi }}
                    </a>
                  </div>
                </div>
              </dd>
              <dd>
                <div class="icBox">
                  <svg
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    p-id="3963"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 0C294.208 0 117.034667 177.152 117.056 394.922667c0 80.896 24.298667 158.677333 69.781333 224.149333 2.282667 3.925333 4.586667 7.722667 7.296 11.413333l288.277333 379.989333C490.24 1019.2 500.757333 1024 512.021333 1024c11.114667 0 21.696-4.842667 30.848-15.104l286.954667-378.474667c2.837333-3.754667 5.248-7.872 6.570667-10.282667 46.144-66.389333 70.570667-144.256 70.570667-225.173333C906.965333 177.152 729.792 0 512 0zM512 536.170667c-77.781333 0-141.077333-63.296-141.077333-141.098667 0-77.781333 63.296-141.056 141.077333-141.056 77.781333 0 141.077333 63.296 141.077333 141.056C653.077333 472.874667 589.781333 536.170667 512 536.170667z"
                      fill="#9a9b9b"
                    ></path>
                  </svg>
                </div>
                <div>
                  <div class="p2">
                    {{ shu.synopsis.hezuopeizhi.dizhi }}
                  </div>
                </div>
              </dd>
            </dl>
          </div>
          <div class="re">
            <dl v-for="(item, index) in shu.lie" :key="index">
              <dt>
                <router-link to="/">{{ item.name }}</router-link>
              </dt>
              <dd v-for="(item2, index) in item.list2" :key="index">
                <router-link to="/">{{ item2.name }}</router-link>
              </dd>
            </dl>
            <div class="follow">
              <dl>
                <dt>关注我们</dt>
                <ol>
                  <!-- 微信 -->
                  <li>
                    <el-popover
                      placement="bottom"
                      title=""
                      width="100"
                      trigger="hover"
                    >
                      <div class="code">
                        <el-image
                          :src="require('@/assets/gzh-ewm.jpg')"
                          fit="contain"
                        ></el-image>
                      </div>

                      <div class="icBox wx" slot="reference">
                        <svg
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          width="20"
                          height="20"
                        >
                          <path
                            d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z"
                            fill="#7f7f7f"
                          ></path>
                        </svg>
                      </div>
                    </el-popover>
                  </li>

                  <!-- 视频号 -->
                  <li>
                    <el-popover
                      placement="bottom"
                      title=""
                      width="100"
                      trigger="hover"
                    >
                      <div class="code">
                        <el-image
                          :src="require('@/assets/sph-ewm.jpg')"
                          fit="contain"
                        ></el-image>
                      </div>

                      <div class="icBox sph" slot="reference">
                        <svg
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          width="20"
                          height="20"
                        >
                          <path
                            d="M143.392 131.744c81.824-24.576 180.032 70.464 336.064 325.248 17.536 28.608 32.544 52 33.376 52.032 0.832 0 16.64-24.768 35.072-55.04 155.168-254.56 253.44-348.096 336.896-320.704 53.024 17.408 75.392 68.608 75.2 172.16-0.384 201.44-97.216 517.12-176.256 574.592-65.088 47.296-162.336-12.256-252.992-154.976-8.992-14.208-17.216-25.856-18.208-25.888-0.992 0-8.992 11.552-17.76 25.728-47.776 77.248-106.368 137.12-156.608 160.032-24.416 11.136-66.88 12.672-84.8 3.04-48.832-26.24-103.808-140.16-146.4-303.488C38.912 323.52 52.16 159.2 143.392 131.744zM827.296 235.52c-51.808 40.256-118.592 129.92-216.384 290.56l-46.176 75.776 15.808 28.288c39.712 71.2 85.6 131.072 122.624 160 25.088 19.648 33.376 15.52 55.296-27.648 68.928-135.52 127.68-413.184 108.48-512.992-5.76-30.048-14.816-33.248-39.648-13.984zM166.752 226.976c-18.496 18.272-13.696 136.704 10.304 254.912 28.96 142.72 89.92 308.736 116.736 318.048 26.08 9.056 97.792-72.96 154.112-176.256l12.32-22.624-39.52-64.864c-105.92-173.76-174.976-266.592-225.792-303.488-15.616-11.328-21.312-12.48-28.16-5.728z"
                            fill="#7f7f7f"
                          ></path>
                        </svg>
                      </div>
                    </el-popover>
                  </li>

                  <!-- 抖音 -->
                  <li>
                    <a
                      href="https://www.douyin.com/user/MS4wLjABAAAAjsXrKlgirpDBdECxsNbn6Ie4Vb4d6HOHM3nzz5ZHFfMAIVSVRG5TnL43Pfq_Oh2X?from_tab_name=main"
                      target="_blank"
                    >
                      <div class="icBox dy">
                        <svg
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          width="20"
                          height="20"
                        >
                          <path
                            d="M937.4 423.9c-84 0-165.7-27.3-232.9-77.8v352.3c0 179.9-138.6 325.6-309.6 325.6S85.3 878.3 85.3 698.4c0-179.9 138.6-325.6 309.6-325.6 17.1 0 33.7 1.5 49.9 4.3v186.6c-15.5-6.1-32-9.2-48.6-9.2-76.3 0-138.2 65-138.2 145.3 0 80.2 61.9 145.3 138.2 145.3 76.2 0 138.1-65.1 138.1-145.3V0H707c0 134.5 103.7 243.5 231.6 243.5v180.3l-1.2 0.1"
                            fill="#7f7f7f"
                          ></path>
                        </svg>
                      </div>
                    </a>
                  </li>

                  <!-- 小红书 -->
                  <li>
                    <a
                      href="https://www.xiaohongshu.com/user/profile/65e54bdb000000000500daf1?xsec_token=ABn8RzfBWtsMsN9q5y4dbd0iMlEcWTnAr_JETkCb1ghuc%3D&amp;xsec_source=pc_search"
                      target="_blank"
                    >
                      <div class="icBox xhs">
                        <svg
                          viewBox="0 0 1700 1024"
                          version="1.1"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M1556.58367989 666.84618125c-29.0770875 60.29219619-60.07839434 76.86185977-124.32592969 66.70625977-41.2638082-6.52096406-63.81993076-30.68060362-69.91329112-78.89298047 24.90794648 0 49.49518974-0.64140645 73.97553165 0.21380273 16.46276308 0.64140645 23.94583682-4.91744883 23.30443036-22.23542021-0.96210967-25.01484698 0.21380185-50.24349668-0.64140644-75.25834453-0.74830781-20.95260732-12.1867207-34.63594278-33.56693174-35.06354649-42.9742248-0.96210967-85.94844961-0.32070323-133.0918163-0.32070322v212.84000508h-95.67644591V523.38496221h-96.53165507v-98.34897218h93.85912793v-83.48972607h-62.32331602v-96.10404961c20.52500273-0.96210967 40.19479717-2.03111982 63.28542569-3.10013086v-33.35312987H1291.36215693c-3.7415373 26.83216494 6.7347668 35.49115107 34.63594278 35.91875477 74.082433 1.17591152 113.10131865 42.86732432 114.49103203 117.27045968 0.42760459 20.41810224 0.10690137 40.83620362 0.10690136 63.28542656 59.8645916-2.77942763 96.74545693 21.91471699 115.98764678 72.69271875v168.68986787zM1292.00356338 336.94951924c0 29.39779073-1.17591152 51.31250771 0.74830781 72.9065206 0.53450508 5.55885527 10.79700645 14.43164238 16.56966358 14.43164239 11.65221562 0.10690137 33.03242666-3.7415373 33.46003036-7.91067744 2.45872441-22.3423207 3.42083408-46.39505888-3.20703134-67.34766622-2.24492256-7.26927188-27.47357138-7.37617324-47.57097041-12.07981933zM357.3676206 208.88205224c-0.21380185 146.34754717-0.10690137 292.8019957-0.85520829 439.14954287-0.32070323 62.64401924-39.55339072 96.10405049-98.6696754 86.26915284-38.69818242-6.41406357-59.65078974-32.60482208-61.14740449-78.7860791h64.24753448V208.98895362c32.17721836-0.10690137 64.35443672-0.10690137 96.4247537-0.10690138zM767.11937276 208.88205224c-23.62513359 47.14336582-50.02969482 93.11082099-66.81316026 137.90236378 39.33958886-2.24492256 74.61693808-4.27604238 116.73595372-6.7347668-22.23542021 44.89844414-42.01211513 84.6656376-61.78881094 124.53973154-2.67252627 5.34505254-5.23815205 10.90390781-7.91067833 16.24896124-20.73880547 41.58451143-20.63190411 41.69141191 25.33555107 42.9742248 4.81054747 0.10690137 9.51419443 0.74830781 18.28008018 1.49661474-12.93502763 25.33555019-24.26654003 48.42617871-36.45325986 71.08920264-2.03111982 3.7415373-7.48307373 8.01757969-11.3315124 8.01757968-33.99453633-0.10690137-68.30977588 1.06901016-102.09050948-2.67252626-24.4803419-2.77942763-33.78073448-21.27331055-24.26654003-44.57774092 11.65221562-28.75638428 25.44245156-56.65756026 38.2705787-84.87943946 4.38294375-9.72799629 8.76588662-19.45599258 15.28685069-33.88763495-18.9214875 0-32.60482208 0.42760459-46.28815752-0.10690138-40.62240176-1.38971338-54.09193448-19.45599258-37.41536953-56.33685703 26.40456123-58.36797685 55.90925244-115.4531417 84.02423027-173.07281162h96.42475372zM62.10690137 576.40788653c6.09336036-33.78073448 13.79023594-67.4545667 17.85247646-101.44910304 5.13125068-42.76042295 7.16237051-85.84154912 10.69010508-130.73999237h101.44910391c-17.21107002 115.98764678 3.42083408 238.81696172-72.58581827 345.50421679-20.31120088-35.70495293-38.91198516-68.52357773-57.51276855-101.34220254 0.10690137-3.84843779 0.10690137-7.91067832 0.10690137-11.97291885zM1556.58367989 305.30680596c-21.70091426 37.73607276-56.01615381 38.69818242-92.79011778 32.92552529-11.01080918-47.89167363-3.10013086-79.32058418 22.44922207-90.97279893 23.83893545-10.90390781 45.64675107-2.24492256 70.34089571 28.00807647v30.03919717z"
                            fill="#7f7f7f"
                          ></path>
                          <path
                            d="M998.6670626 639.47951035c26.40456123 0 51.20560635 0.53450508 76.00665146-0.21380186 15.60755391-0.42760459 20.41810224 5.98645898 21.38021192 21.27331055 4.81054747 76.11355283 5.23815205 76.11355283-71.73060996 76.11355284H752.36702715c16.8903668-33.35312989 30.57370224-62.64401924 46.7157621-90.43829473 2.99322949-5.23815205 16.03515849-6.20026172 24.4803419-6.41406358 23.94583682-0.8552083 47.998575-0.32070323 74.29623487-0.32070321V341.33246211h-61.46810772v-94.60743575h223.10250556v93.11082101h-60.93360263c0.10690137 100.59389472 0.10690137 198.19455996 0.10690137 299.64366298zM425.89119834 343.36358281h95.03504033c4.5967456 58.68868008 2.56562578 117.80496474 15.28685068 173.6073167 14.96614834 65.3165455-8.87278799 115.88074629-39.76719345 167.40705499-46.18125703-40.4085999-71.30300537-161.42059599-70.55469756-341.01437169zM597.03979062 638.30359883h153.93752227c-17.21107002 33.6738331-30.7875041 61.1474045-45.64675107 87.97957031-2.77942763 4.91744883-10.90390781 9.62109492-16.67656495 9.72799629-44.89844414 0.74830781-89.79688828 0.42760459-141.32319785 0.42760371 19.56289307-38.80508378 35.59805244-70.3408957 49.70899161-98.13517031z"
                            fill="#7f7f7f"
                          ></path>
                        </svg>
                      </div>
                    </a>
                  </li>

                  <!-- bilibili -->
                  <li>
                    <a
                      href="https://space.bilibili.com/3546710502541335?spm_id_from=333.337.0.0"
                      target="_blank"
                    >
                      <div class="icBox bili">
                        <svg
                          viewBox="0 0 2299 1024"
                          version="1.1"
                          width="20"
                          height="20"
                        >
                          <path
                            d="M1775.840814 322.588002c6.0164 1.002733 53.144869-9.525967 55.150336-6.016401 3.0082 4.5123 24.065601 155.92504 18.550567 156.927774s-44.621635 10.027334-44.621635 10.027334c-3.0082-20.556034-28.577901-147.903173-29.079268-160.938707m75.205003-14.539634l20.556034 162.944174c10.5287-0.501367 53.144869-3.509567 57.155803-4.010934-6.0164-61.668103-16.545101-158.933241-16.545101-158.93324-20.054668-4.010934-41.112069-4.010934-61.166736 0m-40.610702 226.116376s92.752838-23.564234 126.344406-12.0328c17.046467 61.668103 48.131202 407.611118 51.139402 421.649386-21.057401 2.506833-90.246004 8.523234-95.761037 10.027333-4.5123-26.071068-81.72277-403.098818-81.722771-419.643919m343.436183-207.565809c5.515034 1.5041 54.648969-5.013667 55.150335-1.5041 1.002733 12.032801 6.0164 157.42914 0.501367 157.930507s-44.621635 4.010934-44.621635 4.010934c-1.002733-20.054668-12.032801-146.90044-11.030067-160.437341m75.70637-4.010933l4.010933 160.938707c10.5287 0 52.643502 2.506833 57.155803 2.005467-1.002733-61.668103 0-158.933241 0-158.933241-20.054668-3.509567-40.610702-5.013667-61.166736-4.010933m-64.676303 216.089043s94.758304-12.534167 126.845772 2.506833c7.019134 72.196803 6.0164 408.613852 7.019134 422.652119-21.558768 0-90.246004 1.002733-95.761038 2.005467-1.002733-26.071068-39.607968-410.619319-38.103868-427.164419m-220.099977-413.627519c54.648969 278.759879 96.262404 755.058234 97.766504 785.641602 0 0 43.117535 1.002733 91.750105 4.010934C2105.740095 614.383415 2070.644427 134.575493 2071.145794 119.033126c-12.032801-13.536901-126.344406 6.0164-126.344406 6.0164m-120.328005 659.297196c-10.5287-78.213204-290.291313-166.955108-447.720454-138.377206 0 0-19.553301-172.470141-27.073801-339.425248-6.517767-143.390873-1.002733-282.770813 0.501366-305.833681-10.5287-7.5205-123.837572 46.627102-185.004308 69.188603 0 0 73.199537 309.844614 126.344406 952.59671 0 0 84.730971 9.0246 230.12731-19.051934s317.365114-115.815705 302.825481-219.097244m-341.932083 140.88404l-24.566967-176.982441c6.0164-3.0082 156.927774 53.144869 172.971507 63.172203-2.506833 11.030067-148.40454 113.810238-148.40454 113.810238M610.664628 322.588002c6.0164 1.002733 53.144869-9.525967 55.150335-6.016401 3.0082 4.5123 24.065601 155.92504 18.550568 156.927774s-44.621635 10.027334-44.621635 10.027334c-3.0082-20.556034-28.577901-147.903173-29.079268-160.938707m75.205003-14.539634l20.556034 162.944174c10.5287-0.501367 53.144869-3.509567 57.155803-4.010934-6.517767-61.668103-16.545101-158.933241-16.545101-158.93324-20.054668-4.010934-41.112069-4.010934-61.166736 0m-40.610702 226.116376s92.752838-23.564234 126.344406-12.0328c17.046467 61.668103 48.131202 407.611118 51.139402 421.649386-21.057401 2.506833-90.246004 8.523234-95.761037 10.027333-4.5123-26.071068-81.72277-403.098818-81.722771-419.643919m343.436182-207.565809c5.515034 1.5041 54.648969-5.013667 55.150336-1.5041 1.002733 12.032801 6.0164 157.42914 0.501367 157.930507s-44.621635 4.010934-44.621635 4.010934c-1.002733-20.054668-11.531434-146.90044-11.030068-160.437341m75.706371-4.010933l4.010933 160.938707c10.5287 0 52.643502 2.506833 57.155803 2.005467-1.002733-61.668103 0-158.933241 0-158.933241-20.054668-3.509567-40.610702-4.5123-61.166736-4.010933m-64.676303 216.089043s94.758304-12.534167 126.845772 2.506833c7.019134 72.196803 6.0164 408.613852 7.019134 422.652119-21.558768 0-90.246004 1.002733-95.761038 2.005467-0.501367-26.071068-39.607968-410.619319-38.103868-427.164419m-220.099977-413.627519c54.648969 278.759879 96.262404 755.058234 97.766504 785.641602 0 0 43.117535 1.002733 91.750105 4.010934-28.577901-300.318647-63.67357-780.126569-63.172203-796.170303-12.032801-13.035534-126.344406 6.517767-126.344406 6.517767m-120.328005 659.297196c-10.5287-78.213204-290.291313-166.955108-447.720454-138.377206 0 0-19.553301-172.470141-27.073801-339.425248-6.517767-143.390873-1.002733-282.770813 0.501366-305.833681C174.475608-6.308547 61.166736 47.337689 0 69.89919c0 0 73.199537 309.844614 126.344406 952.59671 0 0 84.730971 9.0246 230.12731-19.051934s317.365114-115.815705 302.825481-219.097244m-341.932083 140.88404l-24.566967-176.982441c6.0164-3.0082 156.927774 53.144869 172.971507 63.172203-2.506833 11.030067-148.40454 113.810238-148.40454 113.810238"
                            fill="#7f7f7f"
                          ></path>
                        </svg>
                      </div>
                    </a>
                  </li>
                </ol>
              </dl>
            </div>
          </div>
        </div>

        <div class="copyRght txt-c mt-20 tit-14">
          <p>
            {{ shu.synopsis.hezuopeizhi.beian }} &nbsp; | &nbsp;
            <span @click="showDialog(1)" class="cur">用户协议 · </span>
            <span @click="showDialog(2)" class="cur">
              隐私政策
            </span>
          </p>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="50%"
      top="0"
      :before-close="handleClose"
    >
      <div class="info">
        <!-- 协议内容展示区域 -->
        <div class="info tit-333" v-html="dialogContent.neirong"></div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 右侧悬浮 -->
    <div class="float-contact">
      <!-- 右侧悬浮按钮容器 -->
      <div class="float-btn-wrapper">
        <!-- 在线客服按钮 -->
        <div
          class="float-btn customer-service"
          @click="toggleServiceForm"
          title="在线客服"
        >
          <i class="iconfont el-icon-service"></i>
          <span class="btn-text">联系客服</span>
        </div>

        <!-- 电话按钮（hover 显示号码） -->
        <div class="float-btn phone-btn">
          <i class="iconfont el-icon-phone-outline"></i>
          <span class="btn-text">联系电话</span>
          <div class="phone-number">{{ phoneNumber }}</div>
        </div>

        <!-- 回到顶部按钮 -->
        <div class="float-btn back-top" @click="backToTop" title="回到顶部">
          <i class="iconfont el-icon-top"></i>
          <span class="btn-text">回到顶部</span>
        </div>
      </div>
    </div>

    <!-- 在线客服表单弹窗（左侧弹出） -->
    <div
      class="service-form-wrapper"
      :class="{
        'form-show': showServiceForm, // 显示状态类
        'form-hide': !showServiceForm, // 隐藏状态类
      }"
    >
      <!-- 表单头部（可收起） -->
      <div class="form-header" @click="toggleServiceForm">
        <h3>在线客服</h3>
        <i
          class="iconfont"
          :class="showServiceForm ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
        ></i>
      </div>
      <!-- 表单内容 -->
      <div class="form-content">
        <div class="form-tip">
          您好，感谢您的关注，当前销售顾问不在线，请填写您的信息，我们尽快和您联系。
        </div>
        <el-form
          ref="serviceForm"
          :model="formData"
          :rules="formRules"
          class="contact-form"
        >
          <el-form-item label="姓名:" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名称：" prop="company">
            <el-input
              v-model="formData.company"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机:" prop="phone">
            <el-input
              v-model="formData.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>

          <el-form-item label="备注:" prop="remark">
            <el-input
              v-model="formData.remark"
              type="textarea"
              rows="4"
              placeholder="请输入备注信息"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm" class="submit-btn"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerComponent",

  data() {
    return {
      shu: { synopsis: { hezuopeizhi: {} } },
      list: [
        {
          name: "整机专区",
          url: "/",
          list2: [
            {
              name: "轮式双臂人形机器人",
              url: "/",
            },
            {
              name: "双足通用人形机器人",
              url: "/",
            },
          ],
        },
        {
          name: "配件专区",
          url: "/",
          list2: [
            {
              name: "自适应智能夹爪",
              url: "/",
            },
            {
              name: "机械臂",
              url: "/",
            },
            {
              name: "关节模组",
              url: "/",
            },
          ],
        },
        {
          name: "组装视频",
          url: "/video",
        },
        {
          name: "帮助与支持",
          url: "/",
        },
      ],

      // 弹窗
      dialogVisible: false,
      // 弹窗内容
      dialogContent: "", // 用于存储当前要显示的内容类型

      // 电话号
      phoneNumber: "400 756 1299",
      // 是否显示客服表单
      showServiceForm: false,
      // 表单数据
      formData: {
        name: "",
        phone: "",
        // city: "",
        remark: "",
      },
      // 表单校验规则
      formRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        remark: [{ message: "请输入备注", trigger: "blur" }],
      },
    };
  },
  created() {
    this.CSH(); //导航栏数据初始化
  },

  methods: {
    // 显示弹窗
    showDialog(type) {
      let apiParam = "";
      // console.log(1);
      // 根据类型设置标题和接口参数
      if (type === 1) {
        this.dialogTitle = "用户协议";
        apiParam = "用户协议";
      } else if (type === 2) {
        this.dialogTitle = "隐私政策";
        apiParam = "隐私政策";
      }

      // 有接口参数时发起请求
      if (apiParam) {
        // 发起POST请求获取协议内容
        this.$post(
          "k=wenzhang&c=xiangqing",
          {
            id: apiParam,
            // ye: 1, // 页码（固定第一页）
            // jitiao: 20, // 条数（足够获取所有协议）
          },
          (response) => {
            // 请求成功且有有效内容
            if (response.shi === 1) {
              console.log(response);
              this.dialogContent = response.shu;
            } else {
              // 请求失败时显示提示文本
              this.dialogContent =
                type === 1
                  ? "获取用户服务协议内容失败"
                  : "获取隐私政策内容失败";
            }
          },
          (error) => {
            // 网络请求失败的容错处理
            console.error("协议内容请求失败：", error);
            this.dialogContent = "网络异常，获取协议内容失败，请稍后重试";
          },
        );
      }

      // 显示弹窗
      this.dialogVisible = true;
    },

    handleClose(done) {
      // 关闭对话框的处理逻辑
      done();
    },

    // 接口数据
    CSH() {
      var that = this;
      that.$post("k=company&c=tabbar", { leixing: 2 }, function(s) {
        that.shu = s.shu;
      });
    },

    // 回到顶部（平滑滚动）
    backToTop() {
      const scrollToTop = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
          window.scrollTo(0, currentPosition - 50);
          requestAnimationFrame(scrollToTop);
        }
      };
      scrollToTop();
    },

    // 切换客服表单显示/隐藏
    toggleServiceForm() {
      this.showServiceForm = !this.showServiceForm;
    },

    // 提交表单
    submitForm() {
      var that = this;
      that.$refs.serviceForm.validate((valid) => {
        if (valid) {
          // 这里替换为实际的接口请求逻辑
          console.log(valid);
          that.$post("k=company&c=Service", that.formData, function(s) {
            that.$message.success("提交成功，我们会尽快联系您！");
            that.$refs.serviceForm.resetFields();
            that.showServiceForm = false;
          });
        } else {
          that.$message.error("请填写完整信息！");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  background: url("../assets/footer-bj.jpg");
  background-size: cover;
  padding: 0.5rem 0 0.2rem;

  .box {
    display: flex;
    justify-content: space-between;
  }

  .logo .el-image {
    max-width: 2rem;
  }

  .le {
    width: auto;

    dl {
      margin-top: 0.3rem;
    }
    dd {
      display: flex;
      align-items: center;
      margin: 0.1rem 0;
    }
    dd .icBox {
      width: 0.2rem;
      min-width: 15px;
      margin-right: 0.12rem;
      svg {
        max-width: 100%;
      }
    }
    dd .p1 {
      font-size: var(--font14);
      opacity: 0.77;
      color: #535353;
    }

    dd .p2,
    dd .p2 a {
      font-size: var(--font15);
      color: #202020;
    }
  }

  .re {
    width: 70%;
    display: flex;
    justify-content: space-between;
    dl {
      width: auto;
    }
    dl dt {
      margin-bottom: 0.3rem;
    }
    dl dt a {
      color: #404040;
    }
    dl dd {
      margin: 0.1rem 0;
      > a {
        font-size: var(--font15);
        color: #7f7f7f;

        &:hover {
          color: #333;
        }
      }
    }
  }

  /* 关注我们栏目 */
  .follow {
    ol {
      display: grid;
      grid-template-columns: repeat(5, auto);
      width: 100%;
      justify-content: flex-start;
    }
    ol li {
      padding: 0 0.1rem;
      box-sizing: border-box;
      position: relative;

      &:hover .icBox svg path {
        fill: #333;
      }
    }
    ol li .icBox {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }

    ol li .icBox svg {
      width: 100%;
    }
    ol li .icBox.xhs {
      width: 0.4rem;
      min-width: 30px;
    }
    ol li .icBox.bili {
      width: 0.4rem;
      min-width: 30px;
    }
  }
}

// 全局过渡动画
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}
.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

// 右侧悬浮按钮容器
.float-btn-wrapper {
  padding: 0.3rem 0.1rem;
  position: fixed;
  right: 0%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  background: linear-gradient(-14deg, #001ff5 0%, #41b9e0 100%);
  border-radius: 100px;
  // 悬浮按钮通用样式
  .float-btn {
    // background: #008feb;
    color: #fff;
    margin-bottom: 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    transition: all 0.3s ease;
    &:last-child {
      margin-bottom: 0;
    }
    .iconfont {
      font-size: var(--font20);
      margin-bottom: 0.1rem;
    }

    .btn-text {
      font-size: var(--font12);
      transition: opacity 0.3s ease;
    }
  }

  // 电话按钮特殊样式（hover显示号码）
  .phone-btn {
    .phone-number {
      position: absolute;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
      white-space: nowrap;
      background: #fff;
      color: #008feb;
      padding: 0.15rem 0.2rem;
      border-radius: 0.05rem;
      box-shadow: 0 0.06rem 0.16rem rgba(0, 0, 0, 0.1);
      font-size: var(--font18);
      opacity: 0;
      pointer-events: none;
      transition: all 0.3s ease;
      &::after {
        content: "";
        position: absolute;
        left: 100%;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 0.08rem solid transparent;
        border-bottom: 0.08rem solid transparent;
        border-left: 0.12rem solid #fff;
      }
    }

    &:hover .phone-number {
      opacity: 1;
      right: 150%;
    }
  }

  // 回到顶部按钮
  .back-top {
  }
}

// 弹窗
/deep/ .el-dialog {
  top: 5vh;
  margin: 5vh auto;
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
    .info {
      color: initial;

      h2 {
        margin: revert;
      }
      ol {
        margin: revert;
        padding: revert;
        li {
          margin: inherit;
          padding: revert;
          list-style: inherit;
        }
      }

      ul {
        margin: revert;
        padding: revert;
        li {
          margin: inherit;
          padding: revert;
          list-style: initial;
        }
      }
    }
  }
  .el-dialog__footer {
    text-align: center;

    .el-button--primary {
      border: 0;
      background: #000000;
    }
  }
}

// 示例：改为向上弹出
.service-form-wrapper {
  transform: translateY(calc(100% - 0.48rem));
}
.service-form-wrapper.form-show {
  transform: translateY(0);
}

// 客服表单容器
.service-form-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 3.2rem;
  border-radius: 0.1rem 0.1rem 0 0;
  box-shadow: 0 2px 0.12rem rgba(0, 0, 0, 0.1);
  z-index: 999;
  overflow: hidden;
  transition: transform 0.3s ease;

  // 表单头部
  .form-header {
    background: #008feb;

    color: #fff;
    padding: 0 0.2rem;
    height: 0.48rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    h3 {
      font-size: var(--font16);
      margin: 0;
    }

    .iconfont {
      font-size: var(--font20);
    }
  }

  // 表单内容
  .form-content {
    padding: 0.2rem;
    background: #fff;
    .form-tip {
      font-size: var(--font14);
      color: #666;
      margin-bottom: 0.1rem;
    }

    .contact-form {
      .el-form-item {
        margin-bottom: 0.1rem;
      }

      .submit-btn {
        width: 100%;
        background: #008feb;
        border: none;
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  .service-form-wrapper {
    width: 4.5rem;
  }
}

// 适配小屏幕
@media screen and (max-width: 767px) {
  .footer .box {
    flex-wrap: wrap;
    .le {
      width: 100%;

      .logo {
        text-align: center;
      }
    }
    .re {
      width: 100%;
      dl {
        display: none;
      }
      dl.follow {
        display: block;
      }
    }
  }

  .service-form-wrapper {
    width: 100%;
    transform: translateY(100%);

    .form-header {
      // width: 30%;
      height: 36px;
    }
  }

  .float-btn-wrapper {
    padding: 0.5rem 0.1rem;
    top: auto;
    transform: none;
    bottom: 10%;
    .float-btn {
      transform: scale(0.9);
    }
  }

  /deep/ .el-dialog {
    width: 90% !important;
  }
}
</style>
